import React, { useState, useRef } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import idly from '../../../../images/raw_material/rice.png';

const PriceEntry = ({ show, onClose }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const options_units = [
        { value: "1", label: "gms" },
        { value: "2", label: "Kg's" },
        { value: "3", label: "Ltr's" },
        { value: "4", label: "ton's" },
        { value: "5", label: "No's" },
    ];



    const [selectedOption, setSelectedOption] = useState(null);



    const [checklist, setchecklist] = useState([{ id: Date.now() }]);
    // Add new IP configuration
    const handleAddConfig = () => {
        setchecklist([...checklist, { id: Date.now() }]);
    };

    // Delete an IP configuration
    const handleDeleteConfig = (id) => {
        setchecklist(checklist.filter(config => config.id !== id));
    };
    const rice_shop = [
        { value: "0", label: "Basmathi Rice" },
        { value: "1", label: "Ponni Rice" },
    ];
    const pulses = [
        { value: "0", label: "Urad Dal" },
        { value: "1", label: "Chana Dal" },
        { value: "2", label: "Fenugreek" },
    ];
    const salt = [
        { value: "0", label: "Rock Salt" },
        { value: "1", label: "Normal Salt" },
    ];
    const spices = [
        { value: "0", label: "Red Chilli Powder" },
        { value: "1", label: "Cumin Seed" },
    ];
    const oil = [
        { value: "0", label: "Refined Oil" },
        { value: "1", label: "Sunflower Oil" },
        { value: "2", label: "Refinded Coconut Oil" },
    ];
    const vegetable = [
        { value: "0", label: "Tomato" },
        { value: "1", label: "Brinjal" },
        { value: "2", label: "Potato" },
    ];

    const groupedOptions_raw_material = [
        {
            label: "Grains",
            options: rice_shop,
        },
        {
            label: "Pulses",
            options: pulses,
        },
        {
            label: "Seasonings",
            options: salt,
        },
        {
            label: "Whole Spices",
            options: spices,
        },

        {
            label: "Oil",
            options: oil,
        },

        {
            label: "Vegetables",
            options: vegetable,
        }

    ];
    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );
    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };
    const [isVisible, setIsVisible] = useState({
        receipe_notes: false,
    });
    const toggleDiv = (section) => {
        setIsVisible((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };
    const steamed = [
        { value: "0", label: "Idly" },
        { value: "1", label: "Puttu" },
    ];
    const rice = [
        { value: "0", label: "Dosai" },
        { value: "1", label: "Uthappam" },
    ];
    const groupedOptions_items = [
        {
            label: "Steamed Food",
            options: steamed,

        },
        {
            label: "Rice Based Food",
            options: rice,
        },
    ];
    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Price</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className="col-lg-12">
                            <div className="d-flex align-items-center justify-content-start gap-2">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={idly} className='border rounded px-1 py-0'>
                                        <img src={idly} alt="Basmathi Rice" className='cursor-pointer w-60px h-60px' />
                                    </div>
                                </LightGallery>
                                <div className=''>
                                    <label className='text-black font-w400 fs-5'>Basmathi Rice</label>
                                    <label className='text-black me-2 ms-2'>|</label>
                                    <label className='text-black font-w400 fs-5'>Tata Sampann</label>
                                    {/* <label className='text-black me-2 ms-2'>|</label>
                                    <label className='text-black font-w400 fs-5'>Idly</label> */}
                                    <div className='d-block mt-1'>
                                        {/* <label className='text-black font-w400 fs-7'>Quantity</label>
                                        <Badge bg="warning" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>10</Badge>
                                        <label className='text-black me-2 ms-2'>|</label> */}
                                        <label className='text-black font-w400 fs-7'>Unit</label>
                                        <Badge bg="success" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>Kg's</Badge>
                                        {/* <label className='text-black me-2 ms-2'>|</label>
                                        <label className='text-black font-w400 fs-7'>Size</label>
                                        <Badge bg="info" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>9 cm</Badge> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-lg-12 mb-4">
                            <label className="text-black font-w500 fs-7">Quantity</label>
                            <input type="text" className="form-control" placeholder="Enter Quantity" />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-lg-12 mb-4">
                            <label className="text-black font-w500 fs-7">Amount<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Amount" />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Submit  <i className="fas fa-angle-double-right ms-2"></i> </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default PriceEntry;
